import { ITicketFormData, TicketGroupsState } from "../types";


export const defaultTicketFormDetail:ITicketFormData = {
  groupId: '',
  projectId: '',
  title: "",
  type: "",
  status: "",
  assignedTo: "",
  dueDate: '',
  effortEstimated: [],
  effortActual: [],
  tags: [],
  longDescription: '',
  checklists: [],
  attachments: [],
  customFields: [],
  release: "",
  sprint: "",
  epic: "",
  file: [],
};

export const initialState: TicketGroupsState = {
  groupForm: {
    name: {
      value: "",
      error: "",
    },
    description: {
      value: "",
      error: "",
    },
  },
  groups: [],
  isLoading: false,
  ticketFormData: {...defaultTicketFormDetail },
};